<template>
  <base-dialog
    :visible.sync="innerVisible"
    title="发送资料清单"
    :confirm-loading="loading"
    @confirm="handleConfirm"
  >
    <div class="product-mateial-detail-dialog">
      <div class="form-item">
        <div class="item-label">客户身份：</div>
        <div class="item-content">
          <el-select v-model="selectIdentityIndex">
            <el-option
              v-for="(item, index) in currIdentityList"
              :key="index"
              :value="index"
              :label="identities[item]"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/pages/work-wx/components/base-dialog.vue';
import counrtyApiService from '../../../services/country-api-service.js';

export default {
  components: {
    BaseDialog,
  },
  props: {
    visible: Boolean,
    product: Object,
  },
  data() {
    return {
      loading: false,
      selectIdentityIndex: 0,
      identities: [
        '在职人员',
        '自由职业者',
        '退休人员',
        '在校学生',
        '学龄前儿童',
        '通用身份',
      ],
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    // 当前支持的身份
    currIdentityList() {
      const list = [];
      try {
        this.product.material.forEach((item) => {
          list.push(item.identity_id);
        });
      } catch (error) {
        //
      }
      return list;
    },
    // 被选中的职业id
    currSelectedIdentityId() {
      return this.currIdentityList[this.selectIdentityIndex];
    },
  },
  watch: {
    innerVisible(value) {
      if (value) {
        this.reset();
      }
    },
  },
  methods: {
    reset() {
      this.selectIdentityIndex = 0;
    },
    async handleConfirm() {
      try {
        this.loading = true;
        const { url } = await counrtyApiService.getMaterialDetailFile({
          online: 1, // 固定在线办理
          identity_id: this.currSelectedIdentityId,
          visa_product_id: this.product.visa_product_id,
          product_name: this.product.product_name,
        });

        const data = `${this.product.product_name_short}，${
          this.identities[this.currSelectedIdentityId]
        }的资料清单链接:\n${url}`;
        console.log('复制的内容', data);
        ww.setClipboardData({
          data,
          success() {},
          fail() {},
        });
        this.loading = false;
        this.$emit('update:visible', false);
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.product-mateial-detail-dialog {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  .form-item {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 14px;
    color: #222;
    &:last-child {
      margin-bottom: 0;
    }

    // .item-label{
    // }
    .item-content {
      width: 150px;
    }
  }
}
</style>
